module.exports = __webpack_public_path__ + "media/images/client/AdCatalog/banner-whatsapp-9a07b962f039ae61dd9fa49b81d09777.svg";